var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouticonorange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_17153",
    "data-name": "Groupe 17153",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12032",
    "data-name": "Trac\\xE9 12032",
    d: "M41.03.529l2.9,1.508a6.9,6.9,0,0,1,3.651,6.135v9.82a3.232,3.232,0,0,0,3.1-3.266V10.356h1.668l-.312.324a1.123,1.123,0,0,0,0,1.54,1.022,1.022,0,0,0,1.481,0l2.045-2.129a1.121,1.121,0,0,0,.018-1.638l-.01-.011L53.515,6.31a1.011,1.011,0,0,0-1.481,0,1.123,1.123,0,0,0,0,1.549l.3.314H50.678V3.8A3.235,3.235,0,0,0,47.522.529Zm-3.883.847A2.442,2.442,0,0,0,34.926,3.8V14.469A5.073,5.073,0,0,0,37.6,18.984l4.428,2.3A2.382,2.382,0,0,0,45.421,19.1V8.172a4.649,4.649,0,0,0-2.457-4.136L38.32,1.617A2.171,2.171,0,0,0,37.147,1.376Z",
    transform: "translate(-34.926 -0.529)",
    fill: "#f06649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticonorange);
export default __webpack_public_path__ + "static/media/logout icon orange.dc44373a45cc375f275c96bdf4e5606f.svg";
export { ForwardRef as ReactComponent };